import { motion } from "framer-motion";
import SampleCard from "./SampleCard";

export default function FinishChapter({ chapter, index }) {
  const alt = index % 2 === 1;
  const count = chapter.designs.length;
  return (
    <section
      id={chapter.id}
      data-testid={`chapter-${chapter.id}`}
      className={`scroll-mt-[72px] py-24 lg:py-32 ${alt ? "bg-bone2" : "bg-bone"}`}
    >
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 border-b-2 border-ink pb-10 mb-14 lg:mb-16"
        >
          <div>
            <div className="flex items-end gap-4 sm:gap-6 mb-7">
              <span className="font-serif font-black leading-[0.78] text-7xl sm:text-8xl lg:text-[7.5rem] text-ink" data-testid={`chapter-num-${chapter.id}`}>
                {chapter.num}
              </span>
              <p className="font-mono text-xs sm:text-sm font-medium uppercase tracking-[0.3em] text-ink pb-2 border-l-2 border-ink pl-4 sm:pl-6" data-testid={`chapter-kicker-${chapter.id}`}>
                {count
                  ? `Chapter ${chapter.num} — ${count} designs${chapter.noShades ? "" : ` · ${chapter.colours.length} ${chapter.unit ?? "shades"}`}`
                  : `Chapter ${chapter.num} — coming soon`}
              </p>
            </div>
            <h2 className="font-serif font-black tracking-tight text-ink leading-[1.02] text-5xl sm:text-6xl lg:text-7xl" data-testid={`chapter-title-${chapter.id}`}>
              {chapter.title}{" "}
              <em className="italic text-beiged block sm:inline">{chapter.accent}</em>
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-muted2 lg:text-right lg:pb-2">{chapter.blurb}</p>
        </motion.div>

        {count ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-14">
            {chapter.designs.map((d, i) => (
              <SampleCard key={d.n} chapter={chapter} design={d} index={i} />
            ))}
          </div>
        ) : (
          <motion.div
            data-testid={`coming-soon-${chapter.id}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="border border-dashed border-ink/25 py-20 lg:py-28 flex flex-col items-center justify-center text-center px-6"
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-beiged mb-4">Under curation</p>
            <p className="font-serif italic text-2xl sm:text-3xl text-ink/70 max-w-lg leading-snug">
              Fresh {chapter.title} samples are being photographed for this chapter.
            </p>
          </motion.div>
        )}
      </div>
    </section>
  );
}
